import { useEffect, useState } from "react";
import { supabase } from "@/lib/supabaseClient";

interface AccessLog {
  id: string;
  token: string;
  email: string;
  accessed_at: string;
  ip?: string;
  user_agent?: string;
}

export default function AccessLogsTable() {
  const [logs, setLogs] = useState<AccessLog[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchLogs();
  }, []);

  const fetchLogs = async () => {
    const { data } = await supabase
      .from("beneficiaries_access_log")
      .select("*")
      .order("accessed_at", { ascending: false });

    if (data) setLogs(data);
    setLoading(false);
  };

  if (loading) return <p>Chargement des logs...</p>;

  return (
    <div className="p-6">
      <h2 className="text-2xl font-semibold mb-4">Logs d’accès héritiers</h2>
      <table className="min-w-full bg-white border border-gray-200 shadow-sm rounded-md">
        <thead className="bg-gray-100 text-left text-sm font-semibold">
          <tr>
            <th className="px-4 py-2">Date</th>
            <th className="px-4 py-2">Email</th>
            <th className="px-4 py-2">Token</th>
            <th className="px-4 py-2">IP</th>
            <th className="px-4 py-2">User Agent</th>
          </tr>
        </thead>
        <tbody className="text-sm">
          {logs.map((log) => (
            <tr key={log.id} className="border-t">
              <td className="px-4 py-2">{new Date(log.accessed_at).toLocaleString()}</td>
              <td className="px-4 py-2">{log.email || "—"}</td>
              <td className="px-4 py-2 text-xs text-gray-500">{log.token.slice(0, 8)}...</td>
              <td className="px-4 py-2">{log.ip || "—"}</td>
              <td className="px-4 py-2 overflow-hidden text-ellipsis">{log.user_agent || "—"}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
